import { filter } from 'lodash';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import { useTheme } from '@mui/material/styles';
import {
    Container
} from '@mui/material';

// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { getListaUsuariosByClienteId } from 'src/redux/slices/user';

// components
import actionEditarSenha from 'src/actions/usuarios/actionEditarSenhaUsuario';
import { useSnackbar } from 'notistack';
import useAuth from 'src/hooks/useAuth';
import { HeaderPageComponentConfig } from 'src/components/_dashboard/configuracoes';
import ModalEditarAgente from '../../cadastro/ModalEditarAgente';
import ModalEditarSenhaAgente from '../../cadastro/ModalEditarSenhaAgente';
import TableUsuarios from './TableUsuarios';
import { Card, CardContent } from 'src/@/components/ui/card';
import { ScrollArea } from 'src/@/components/ui/scroll-area';
import actionEditarPerfil from 'src/actions/usuarios/actionEditarPerfil';


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        return filter(array, (_user) => _user.nomeFantasia.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
}

export default function UsuariosComponent({ user }) {
    const dispatch = useDispatch();
    const { usuariosList } = useSelector((state) => state.user);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('nome');
    const [filterName, setFilterName] = useState('');
    const [openEditarSenha, setOpenEditarSenha] = useState(false);
    const [openEditarPerfil, setOpenEditarPerfil] = useState(false);
    const [senha, setSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [usuarioId, setUsuarioId] = useState('');
    const { logout } = useAuth();

    const [dataUsuario, setDataUsuario] = useState(null)

    useEffect(() => {
        dispatch(getListaUsuariosByClienteId(user.clienteId, '1'));
    }, []);


    const handleOpenDialogEditarPerfil = (usuario) => {
        setDataUsuario(usuario);
        setOpenEditarPerfil(true)
    }

    const handleOpenDialogEditarSenha = (data) => {
        setDataUsuario(data)
        setOpenEditarSenha(true)
    }

    const handleCloseDialogEditarSenha = () => {
        setOpenEditarSenha(false)
    }


    const resetarCampos = () => {
        setUsuarioId('');
        setSenha('');
        setConfirmarSenha('');
    }

    async function handleEditStatus(usuarioId, status) {
        try {
            await actionEditarPerfil({
                usuarioId: usuarioId,
                status: status,
            });
            dispatch(getListaUsuariosByClienteId(user.clienteId, '1'));
        } catch (error) {
            console.log('error', error);
        }
    }


    ///// editar usuario
    const handleEditarSenha = () => {
        actionEditarSenha({
            usuarioId: usuarioId,
            password: senha,
            repeatPassword: confirmarSenha,
        }).then(res => {
            dispatch(getListaUsuariosByClienteId(user.clienteId, '1'));
            setOpenEditarSenha(false);
            resetarCampos();
        }).catch(error => console.log('error', error));
    }




    const filteredUsers = applySortFilter(usuariosList, getComparator(order, orderBy), filterName);

    return (

        <Container maxWidth="lg">
            <HeaderPageComponentConfig
                titulo="Usuários"
                descricao={'O recurso usuários contém todos os agentes que sua empresa está envolvida. É possível editar usuários e senhas de acesso.'}
            // actions={<Button variant='contained'>Teste</Button>}
            />


            <ModalEditarSenhaAgente
                open={openEditarSenha}
                dataUsuario={dataUsuario}
                onCallback={() => setOpenEditarSenha(false)}
                onClose={() => setOpenEditarSenha(false)}
                callbackEdit={() => {
                    setOpenEditarSenha(false);
                    resetarCampos();
                }}
            />

            <ModalEditarAgente
                user={user}
                open={openEditarPerfil}
                onClose={() => setOpenEditarPerfil(false)}
                dataUsuario={dataUsuario}
                callbackEdit={() => {
                    setOpenEditarPerfil(false);
                    setDataUsuario(null);
                    dispatch(getListaUsuariosByClienteId(user.clienteId));
                }}
            />

            <div className='mt-5'>
                <ScrollArea className="h-[75vh]">
                    <Card>
                        <CardContent>
                            <TableUsuarios
                                data={filteredUsers}
                                onEditSenha={data => handleOpenDialogEditarSenha(data)}
                                onEditUsuario={data => handleOpenDialogEditarPerfil(data)}
                                changeStatus={(data, value) => handleEditStatus(data._id, value)}
                            />
                        </CardContent>
                    </Card>
                </ScrollArea>
            </div>
        </Container>


    );
}
